<div class="site-selector-container" *ngIf="multiplesiteidsinfo.length > 0">
    <div class="site-pagination-wrapper">
        <button mat-icon-button (click)="prevVisibleSites()" [disabled]="visibleSitesStart === 0"
            *ngIf="multiplesiteidsinfo.length > sitesPageSize">
            &#10094;
        </button>
        <span class="material-symbols-outlined"></span>
        <div class="site-list">
            <div *ngFor="let item of multiplesiteidsinfo | slice:visibleSitesStart:visibleSitesStart+sitesPageSize"
                class="site-item">
                <button id="{{item.SiteId}}" mat-raised-button class="siteName" title={{item.SiteName}}
                    [ngClass]="item.SiteId == ActiveSiteId ? 'active-site' : ''"
                    (click)="switchsite(item.SiteId)">{{item.SiteName}}</button>
            </div>
        </div>
        <button mat-icon-button (click)="nextVisibleSites()"
            [disabled]="visibleSitesStart + sitesPageSize >= multiplesiteidsinfo.length"
            *ngIf="multiplesiteidsinfo.length > sitesPageSize">
            &#10095;
        </button>
    </div>
</div> 